import { combineReducers } from 'redux'

import {
    auth,
    emailVerificationStatusReducer,
    setNewPasswordReducer,
} from '../../features/auth/reducers/auth-reducers'
import {
    editProfileReducer,
    getUserProfileReducer,
    updateNewPasswordReducer,
    uploadProfilePictureReducer,
} from '../../features/profile/reducers/users-profile-reducer'
import {
    adminOrgProfileManagementReducer,
    uploadOrgLogoImageReducer,
    setOrgLogoImageReducer
} from '../../features/organizations/reducers/organizations-reducer'
import { sendSystemNotificationEmailReducer } from '../../features/global/reducers/global-reducer'
import {
    createDuplicateDsrReducer,
    createNewDsrActionReducer,
    createNewDsrReducer,
    editDsrMemberRoleReducer,
    editDsrTeamMembersReducer,
    getDsrActionListByDsrIdReducer,
    getDsrConfigByDsrIdReducer,
    getDsrProspectReducer,
    updateDsrActionReducer,
    updateDsrReducer,
    uploadFilesReducer,
    deleteFilesReducer
} from '../../features/digital-sales-room/reducers/dsr-reducer'
import {
    getPublicDsrConfigByDsrIdReducer,
} from '../../features/digital-sales-room/reducers/public-dsr-reducer'
import {
    createNewDsrFeedPostReducer,
    createNewDsrFeedReplyReducer,
    deleteDsrFeedPostReducer,
    deleteDsrFeedReplyReducer,
    editDsrFeedPostReducer,
    editDsrFeedReplyReducer,
    editDsrReactionReducer,
    getDsrFeedContentByDsrIdReducer,
} from '../../features/digital-sales-room/reducers/dsr-feed-reducer'
import {
    createNewErrorReportReducer,
    getDsrAuthReducer,
    getLoomTokenReducer,
    getLoomVideosReducer,
} from '../../features/digital-sales-room/reducers/dsr-admin-reducer'
import {
    adminOrgUserManagementReducer,
    getAdminOrgProfileReducer,
    resetActivationLinkReducer,
} from '../../features/profile/reducers/admin-users-reducer'
import { dsrPopupReducer } from '../../features/digital-sales-room/components/reducers/dsr-popup-reducer'
import { dsrModalReducer } from '../../features/digital-sales-room/components/reducers/dsr-modal-reducer'
import { changeDsrPageReducer } from '../../features/digital-sales-room/components/reducers/dsr-page-reducer'
import { dsrStatusReducer } from '../../features/digital-sales-room/components/reducers/dsr-status-reducer'
import { showDsrModalReducer } from '../../features/digital-sales-room/components/reducers/show-dsr-modal-reducer'
import { userActionRequiredReducer } from '../../features/digital-sales-room/components/reducers/user-action-required-reducer'
import { userProfileReducer } from '../../features/digital-sales-room/components/reducers/user-profile-reducer'
import { dsrTitleReducer } from '../../features/digital-sales-room/components/reducers/dsr-title-reducer'
import { showDsrModalLoaderReducer } from '../../features/digital-sales-room/components/reducers/show-dsr-modal-loader-reducer'
import { dsrTeamMembersReducer } from '../../features/digital-sales-room/components/reducers/dsr-team-members-reducer'
import { setDsrUserTeamReducer } from '../../features/digital-sales-room/components/reducers/set-dsr-user-team-reducer'
import { setDsrPagesReducer } from '../../features/digital-sales-room/components/reducers/dsr-pages-reducer'
import { draftDsrCurrentPageReducer } from '../../features/digital-sales-room/components/reducers/draft-dsr-current-page-reducer'
import { draftDsrPropertiesReducer } from '../../features/digital-sales-room/components/reducers/draft-dsr-properties'
import { dsrInvalidRequestReducer } from '../../features/digital-sales-room/components/reducers/dsr-invalid-request-reducer'
import { setDsrFaqContentReducer } from '../../features/digital-sales-room/components/reducers/faq-page-content-reducer'
import { getReceivedRoomsSearchResultsReducer, getVaultQueriedDsrReducer, getVaultSearchResultsReducer, getProspectorSearchResultsReducer } from '../../features/vault/reducers/vault-reducer'
import { dsrDisplayLogoImageReducer } from '../../features/digital-sales-room/components/reducers/dsr-logo-image-display-reducer'
import { checkIfExistingUserReducer } from '../../features/digital-sales-room/components/reducers/dsr-invite-user-reducer'
import { accessAuthenticationReducer } from '../../features/auth/reducers/access-auth-reducers'
import { createProspectDsrReducer, sendProspectDsrQueryReducer, updateProspectDsrReducer } from '../../features/digital-sales-room/components/reducers/prospect-dsr-reducer'
import { dsrMainContactReducer } from '../../features/digital-sales-room/components/reducers/dsr-main-contact-reducer'
import { dsrAnalyticsReducer, dsrAnalyticsDetailsReducer } from '../../features/analytics/reducers/dsr-analytics-reducer'
import { setDsrAdminReducer } from '../../features/digital-sales-room/components/reducers/set-dsr-admin-reducer'
import { setPublicDsrEnvironmentReducer } from '../../features/digital-sales-room/reducers/set-public-dsr-environment-reducer'
import { joinPublicDsrReducer } from '../../features/digital-sales-room/reducers/join-public-dsr-reducer'
import { setJoinRoomRequestsReducer } from '../../features/digital-sales-room/components/reducers/set-join-room-requests-reducer'
import { manageJoinRoomRequestReducer } from '../../features/digital-sales-room/components/reducers/join-room-request-reducer'
import { setDsrUiIndicatorsReducer } from '../../features/digital-sales-room/components/reducers/set-ui-indicators-reducer'
import { setUserProfilePictureReducer } from '../../features/profile/reducers/set-user-profile-picture-reducer'
import { setIsMobileViewReducer } from '../../features/auth/reducers/set-mobile-view-reducer'
import { sendCustomerSupportMessageReducer } from '../../features/global/reducers/customer-support-reducer'
import { stripeCheckoutSessionReducer } from '../../features/payments/reducers/payments-reducer'
import { createGenesisUserReducer, offboardUserReducer, editGenesisUserReducer, createNewOrgForExistingUserReducer, manageExistingUserReducer, manageExistingOrgReducer } from '../../features/profile/reducers/app-admin-reducer'
import { setUserPrivilegesReducer } from '../../features/auth/reducers/set-user-privileges-reducer'
import { genesisSetupReducer } from '../../features/auth/reducers/genesis-setup-reducers'
import { setUploadProgressReducer } from '../../features/digital-sales-room/components/reducers/set-upload-progress-reducer'
import { userSelfSetupReducer } from '../../features/profile/reducers/user-self-setup-reducer'
import { setisOrgAdminReducer } from '../../features/digital-sales-room/components/reducers/set-is-org-admin-reducer'
import { setUserActiveOrgTeamMembersReducer } from '../../features/digital-sales-room/components/reducers/set-user-org-team-members-reducer'
import { contactLaunchdeckMessageReducer } from '../../features/marketing/reducers/send-ld-message-reducer'
import { onboardingReducer } from '../../features/new-user-experience/reducers/onboarding-reducer'
import { dsrSharedDocReducer } from '../../features/digital-sales-room/components/reducers/dsr-shared-doc-reducer'
import { userNotificationsReducer, viewedAllUserNotificationsReducer } from '../../features/profile/reducers/user-notifications-reducer'
import { setUserNotificationsReducer } from '../../features/profile/reducers/set-user-notifications-reducer'
import { setDsrSharedDocReducer } from '../../features/digital-sales-room/components/reducers/set-dsr-shared-doc-reducer'
import { setPaginatedUserNotificationsReducer } from '../../features/profile/reducers/set-paginated-user-notifications-reducer'
import { duplicateDsrPageReducer } from '../../features/digital-sales-room/reducers/duplicate-dsr-page-reducer'
import { manageDsrCustomPagesAccessibilityReducer } from '../../features/digital-sales-room/components/reducers/custom-page-accessibility-reducer'
import { setDsrNotificationsReducer } from '../../features/digital-sales-room/components/reducers/set-dsr-latest-notifications-reducer'
import { setDsrActionListOverviewReducer } from '../../features/digital-sales-room/components/reducers/set-dsr-action-list-overview-reducer'
import { setDsrLastUpdatedReducer } from '../../features/digital-sales-room/components/reducers/set-dsr-last-updated-reducer'
import { setDsrSharedDocOverviewReducer } from '../../features/digital-sales-room/components/reducers/set-dsr-shared-doc-overview-reducer'
import { setDsrTemplateIdReducer } from '../../features/digital-sales-room/components/reducers/set-dsr-template-id-reducer'
import { setDsrOwnerIdReducer } from '../../features/digital-sales-room/components/reducers/set-dsr-owner-id-reducer'
import { createDsrTemplateReducer, createDsrWithTemplateReducer, updateDsrTemplateReducer } from '../../features/digital-sales-room/components/reducers/dsr-template-reducer'
import { setIsLockedRoomReducer, setLockedRoomMetadataReducer } from '../../features/auth/reducers/set-locked-room-reducer'
import { setDsrTemplateMainContactReducer } from '../../features/digital-sales-room/components/reducers/set-dsr-template-main-contact-reducer'
import { setHideEditOptionsInvalidLinkReducer } from '../../features/digital-sales-room/components/reducers/set-hide-edit-options-invalid-link-reducer';
import { getZoomOauthRedirectReducer } from '../../features/organizations/reducers/external-integrations-reducer'
import { revokeExternalProviderOauthReducer } from '../../features/organizations/reducers/revoke-external-integration-reducer'
import { setExternalIntegrationsConfigReducer } from '../../features/organizations/reducers/set-external-integrations-config-reducer'
import { getZoomJwtTokenReducer } from '../../features/organizations/reducers/get-zoom-jwt-token-reducer'
import { setDsrZoomLinkIsActiveReducer } from '../../features/digital-sales-room/reducers/set-dsr-zoom-link-is-active-reducer'
import { setZoomCallInSessionReducer } from '../../features/organizations/reducers/set-zoom-call-in-session-reducer'
import { setZoomCallCurrentlyActiveReducer } from '../../features/organizations/reducers/set-zoom-call-currently-active-reducer'
import { access3pIntegrationSignupReducer } from '../../features/auth/reducers/auth-integrations-reducers'
import { setUserSettingsReducer } from '../../features/profile/reducers/set-user-settings-reducer'
import { setIsReadingModeReducer } from '../../features/digital-sales-room/reducers/set-is-reading-mode-reducer'
import { setZoomCallStatusDisplayReducer } from '../../features/organizations/reducers/set-zoom-call-status-display'
import { dsrCreateGenAiReducer } from '../../features/digital-sales-room/components/reducers/dsr-gen-ai-reducer'
import { setGenAiRoomReadyNotitificationReducer, setNotifyGenAiRoomReadyReducer } from '../../features/digital-sales-room/reducers/set-notify-gen-ai-room-ready-reducer'
import { setShowLaunchdeckBrandingReducer } from '../../features/digital-sales-room/components/reducers/set-show-launchdeck-branding-reducer'
import { setIsShrunkHeaderReducer } from '../../features/auth/reducers/set-shrunk-header-reducer'
import { setRestrictPublishAssetReducer } from '../../features/digital-sales-room/components/reducers/set-restrict-publish-asset-reducer'
import { setDsrBrandingReducer } from '../../features/digital-sales-room/components/reducers/set-dsr-branding-reducer'
import { setDsrApplyBrandingReducer } from '../../features/digital-sales-room/components/reducers/set-dsr-apply-branding-reducer'
import { setIsNewUserTourReducer } from '../../features/new-user-experience/reducers/set-is-new-user-tour-reducer'
import { getDsrInviteLinkReducer } from '../../features/digital-sales-room/reducers/get-dsr-invite-link-reducer'
import { setIsProspectorOwnerReducer } from '../../features/digital-sales-room/components/reducers/set-is-prospector-owner-reducer'
import { setStartRoomTourReducer } from '../../features/new-user-experience/reducers/set-start-room-tour-reducer'
import { setOverviewPageIdReducer } from '../../features/digital-sales-room/components/reducers/set-overview-page-id-reducer'
import { setFirstCustomPageIdReducer } from '../../features/digital-sales-room/components/reducers/set-first-custom-page-id-reducer'
import { setProcessingDsrPostsReducer, setProcessingNewDsrPostsReducer } from '../../features/digital-sales-room/components/reducers/set-processing-posts-reducer'
import { manageInternalPortalReducer } from '../../features/profile/reducers/internal-portal-reducer'
import { setDeepModalTransferPayloadReducer } from '../../features/global/reducers/set-deep-modal-transfer-reducer'
import { setFeErrorLogReducer } from '../../features/global/reducers/set-fe-error-log-reducer'
import { manageDsrFaqContentReducer } from '../../features/digital-sales-room/components/reducers/dsr-faq-content-reducer'
import { setNewUserTourHasCompletedReducer } from '../../features/new-user-experience/reducers/set-new-user-tour-has-completed-reducer'
import { setIsArchivedDsrReducer } from '../../features/digital-sales-room/components/reducers/set-is-archived-dsr-reducer'


const rootReducer = combineReducers({

    uploadOrgLogo: uploadOrgLogoImageReducer,
    setOrgLogo: setOrgLogoImageReducer,
    editProfile: editProfileReducer,
    updatePassword: updateNewPasswordReducer,
    uploadProfilePicture: uploadProfilePictureReducer,

    // Global UX
    mobileViewMode: setIsMobileViewReducer,
    shrunkHeaderView: setIsShrunkHeaderReducer,
    lockedRoomCheck: setIsLockedRoomReducer,
    lockedRoomMetadata: setLockedRoomMetadataReducer,

    // User Auth
    auth,
    emailVerificationStatus: emailVerificationStatusReducer,
    userSettings: setUserSettingsReducer,
    setNewPasswordOutcome: setNewPasswordReducer,
    userSelfSetupOutcome: userSelfSetupReducer,
    userNotificationsOutcome: userNotificationsReducer,
    markAllNotificationsAsViewedOutcome: viewedAllUserNotificationsReducer,
    currentUserNotifications: setUserNotificationsReducer,
    currentUserNotificationBatch: setPaginatedUserNotificationsReducer,

    // DSR Authentication
    accessAuthOutcome: accessAuthenticationReducer,
    dsrAuth: getDsrAuthReducer,

    // Product Marketing
    sendSystemNotificationOutcome: sendSystemNotificationEmailReducer,
    contactLaunchdeckOutcome: contactLaunchdeckMessageReducer,

    // DSR mgmt
    allUserDsrs: getVaultQueriedDsrReducer,
    vaultSearchResults: getVaultSearchResultsReducer,
    receivedRoomsSearchResults: getReceivedRoomsSearchResultsReducer,
    prospectorSearchResults: getProspectorSearchResultsReducer,
    dsrConfiguration: getDsrConfigByDsrIdReducer,
    dsrActionList: getDsrActionListByDsrIdReducer,
    createNewDsrActionOutcome: createNewDsrActionReducer,
    updateDsrActionOutcome: updateDsrActionReducer,

    publicDsrConfiguration: getPublicDsrConfigByDsrIdReducer,
    publicDsrEnvironment: setPublicDsrEnvironmentReducer,
    joinPublicDsrOutcome: joinPublicDsrReducer,

    modalTransferPayloadRedux: setDeepModalTransferPayloadReducer,
    isArchivedDsr: setIsArchivedDsrReducer,

    // DSR Team Members
    dsrTeamMembers: dsrTeamMembersReducer,
    dsrMainContact: dsrMainContactReducer,
    editDsrTeamMembersOutcome: editDsrTeamMembersReducer,
    editDsrMemberRoleOutcome: editDsrMemberRoleReducer,
    checkIfExistingUserOutcome: checkIfExistingUserReducer,

    dsrPopup: dsrPopupReducer,
    dsrModal: dsrModalReducer,
    changeDsrPage: changeDsrPageReducer,
    setDsrPages: setDsrPagesReducer,
    dsrUserTeam: setDsrUserTeamReducer,
    dsrAdmin: setDsrAdminReducer,
    dsrOwnerId: setDsrOwnerIdReducer,
    dsrDisplayLogoImages: dsrDisplayLogoImageReducer,
    dsrInvalidRequest: dsrInvalidRequestReducer,
    draftDsrCurrentPage: draftDsrCurrentPageReducer,
    draftDsrProperties: draftDsrPropertiesReducer,
    joinRoomRequests: setJoinRoomRequestsReducer,
    manageJoinRoomRequestOutcome: manageJoinRoomRequestReducer,
    dsrLastSaved: setDsrLastUpdatedReducer,

    showDsrModal: showDsrModalReducer,
    userActionRequired: userActionRequiredReducer,
    dsrStatus: dsrStatusReducer,
    dsrTitle: dsrTitleReducer,
    dsrNotifications: setDsrNotificationsReducer,
    userProfile: userProfileReducer,
    getUserProfile: getUserProfileReducer, 
    overviewPageId: setOverviewPageIdReducer,
    firstCustomPageId: setFirstCustomPageIdReducer,
    showDsrModalLoader: showDsrModalLoaderReducer,
    getDsrInviteLinkOutcome: getDsrInviteLinkReducer,

    prospectorOwner: setIsProspectorOwnerReducer,

    // DSR content mgmt
    dsrFeedContent: getDsrFeedContentByDsrIdReducer,
    createNewDsrFeedPostOutcome: createNewDsrFeedPostReducer,
    editDsrFeedPostOutcome: editDsrFeedPostReducer,
    deleteDsrFeedPostOutcome: deleteDsrFeedPostReducer,

    createNewDsrFeedReplyOutcome: createNewDsrFeedReplyReducer,
    editDsrFeedReplyOutcome: editDsrFeedReplyReducer,
    deleteDsrFeedReplyOutcome: deleteDsrFeedReplyReducer,

    editDsrReactionOutcome: editDsrReactionReducer,
    duplicateDsrPageOutcome: duplicateDsrPageReducer,
    dsrCustomPagesAccessibility: manageDsrCustomPagesAccessibilityReducer,
    dsrMapOverview: setDsrActionListOverviewReducer,

    // DSR Q&A mgmt
    manageDsrFaqContentOutcome: manageDsrFaqContentReducer,
    dsrFaqContent: setDsrFaqContentReducer, 

    // DSR Shared Doc
    dsrSharedDocOutcome: dsrSharedDocReducer,
    currentDsrSharedDocs: setDsrSharedDocReducer,
    dsrSharedDocOverview: setDsrSharedDocOverviewReducer,

    // DSR Analytics
    dsrInsights: dsrAnalyticsReducer,
    dsrDetailedAnalytics: dsrAnalyticsDetailsReducer,

    // DSR Admin mgmt
    createErrorReportOutcome: createNewErrorReportReducer,
    loomToken: getLoomTokenReducer,
    loomVideos: getLoomVideosReducer,

    // DSR UX management
    processingDsrPosts: setProcessingDsrPostsReducer, //Note: This is for updating existing dsr posts to manage UX
    processingNewDsrPosts: setProcessingNewDsrPostsReducer, // Note: This is for newly created dsr post to manage UX

    // DSR file uploads
    fileUploadPercentProcessed: setUploadProgressReducer,
    uploadFilesOutcome: uploadFilesReducer,
    deleteFilesOutcome: deleteFilesReducer,

    // DSR UI management
    dsrUiIndicators: setDsrUiIndicatorsReducer,
    isReadingMode: setIsReadingModeReducer,

    // User DSR Dashboard Management
    createNewDsrOutcome: createNewDsrReducer,
    updateDsrOutcome: updateDsrReducer,
    createDuplicateDsrOutcome: createDuplicateDsrReducer,

    // Prospect DSR mgmt
    createNewProspectDsr: createProspectDsrReducer,
    dsrProspect: getDsrProspectReducer,
    updateProspectDsrOutcome: updateProspectDsrReducer,
    sendProspectDsrQueryOutcome: sendProspectDsrQueryReducer,

    // Admin User actions
    adminOrgProfile: getAdminOrgProfileReducer,
    manageAdminOrgUsersOutcome: adminOrgUserManagementReducer,
    manageAdminOrgProfileOutcome: adminOrgProfileManagementReducer,
    reactivateUserSetupLinkOutcome: resetActivationLinkReducer,

    // User Profile
    thisUserProfilePicture: setUserProfilePictureReducer,
    userPrivileges: setUserPrivilegesReducer,
    userActiveOrgTeamMembers: setUserActiveOrgTeamMembersReducer,

    // Customer Support
    sendCustomerSupportMessageOutcome: sendCustomerSupportMessageReducer,

    // Payments
    stripeCheckoutSessionResponse: stripeCheckoutSessionReducer,

    // Genesis setup
    genesisSetupOutcome: genesisSetupReducer,

    // Super admin
    createGenesisUserOutcome: createGenesisUserReducer,
    offboardUserOutcome: offboardUserReducer,
    editGenesisUserOutcome: editGenesisUserReducer,
    createNewOrgForExistingUserOutcome: createNewOrgForExistingUserReducer,
    manageExistingUserOutcome: manageExistingUserReducer,
    manageExistingOrgOutcome: manageExistingOrgReducer,

    // Onboarding
    onboardingOutcome: onboardingReducer,
    newUserTourIsActive: setIsNewUserTourReducer,
    newUserTourHasCompleted: setNewUserTourHasCompletedReducer,
    roomTourIsActive: setStartRoomTourReducer,

    // Others / Helpers
    isOrgAdmin: setisOrgAdminReducer,

    // Error handling
    feErrorLog: setFeErrorLogReducer,

    // Template Mgmt
    dsrTemplateId: setDsrTemplateIdReducer,
    dsrTemplateMainContact: setDsrTemplateMainContactReducer,
    createDsrTemplateOutcome: createDsrTemplateReducer,
    updateDsrTemplateOutcome: updateDsrTemplateReducer,
    createDsrWithTemplateOutcome: createDsrWithTemplateReducer,

    // Revenue Management
    restrictPublishAsset: setRestrictPublishAssetReducer,

    // Global UIUX
    hideOptionForInvalidLink: setHideEditOptionsInvalidLinkReducer,
    showLaunchdeckBranding: setShowLaunchdeckBrandingReducer,
    dsrBrandingOptions: setDsrBrandingReducer,
    dsrApplyBranding: setDsrApplyBrandingReducer,

    // GEN AI
    createGenAiRoomOutcome: dsrCreateGenAiReducer,
    notifyGenAiRoomReady: setNotifyGenAiRoomReadyReducer,
    genAiRoomReadyNotification: setGenAiRoomReadyNotitificationReducer,

    // External Integrations
    dsrZoomLinkActive: setDsrZoomLinkIsActiveReducer,
    authorisedExternalIntegrationsConfig: setExternalIntegrationsConfigReducer,
    revokeExternalOauthOutcome: revokeExternalProviderOauthReducer,
    getZoomOauthOutcome: getZoomOauthRedirectReducer,
    generatedZoomJwtToken: getZoomJwtTokenReducer,
    zoomCallInSession: setZoomCallInSessionReducer,
    zoomCallCurrentlyActive: setZoomCallCurrentlyActiveReducer,
    zoomCallDisplayStatus: setZoomCallStatusDisplayReducer,
    manage3pIntegrationSignupOutcome: access3pIntegrationSignupReducer,

    // Internal Portal
    saaIntPortRedux: manageInternalPortalReducer,
});

export default rootReducer;
